import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createReduxHistoryContext } from "redux-first-history";
import { createBrowserHistory } from "history";
import { watcherSaga } from "./sagas/rootSaga";
import vinImageReducer from "./entities/userCars";
import userCarsReducer from "./entities/userCars";
import configsReducer from './entities/configs';
import carsReducer from "./entities/cars";
import userFilterReducer from "./entities/userFilter";
import partRequestReducer from "./entities/partRequest";
import notificationsReducer from "./entities/notifications";
import messagesReducer from "./entities/messages";
import partOffersReducer from "./entities/partOffers";
import addressesReducer from "./entities/address";


const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
});

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
    router: routerReducer,
    vinImage: vinImageReducer,
    cars: carsReducer,
    userCars: userCarsReducer,
    configs: configsReducer,
    userFilter: userFilterReducer,
    partRequest: partRequestReducer,
    notifications: notificationsReducer,
    messages: messagesReducer,
    partOffers: partOffersReducer,
    addresses: addressesReducer,
});

const buyerStore = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
        sagaMiddleware,
        routerMiddleware,
    ],
});

const buyerHistory = createReduxHistory(buyerStore);

sagaMiddleware.run(watcherSaga);

export { buyerStore, buyerHistory };
